import qs from 'query-string';
import { getAuthenticatedClient } from './client';
import type * as Groups from './interfaces/groups';

export * as branding from './groups.branding';

export const getGroupUsers = (data: Groups.GetGroupUsers.Request): Promise<Groups.GetGroupUsers.Response> => {
  return getAuthenticatedClient().get(`/groups/users?${qs.stringify(data, { arrayFormat: 'bracket' })}`);
};